var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWeight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.534 4.237a1.244 1.244 0 00-.46-1.106A14.333 14.333 0 0010 0 14.333 14.333 0 00.928 3.13a1.244 1.244 0 00-.462 1.108L2.008 18.88A1.25 1.25 0 003.25 20h13.5a1.25 1.25 0 001.243-1.12zm-2.45 2.846a.417.417 0 01-.417.417h-5.233a.417.417 0 01-.396-.285l-.643-1.93a.433.433 0 00-.79 0l-.643 1.93a.417.417 0 01-.395.285H3.333a.417.417 0 01-.416-.417v-2.61a.417.417 0 01.188-.35 12.018 12.018 0 011.728-.933.417.417 0 01.562.242l.614 1.735a.625.625 0 101.179-.417l-.646-1.824a.328.328 0 01.225-.426 12.234 12.234 0 012.157-.367.417.417 0 01.451.416v.784a.625.625 0 001.25 0v-.786a.417.417 0 01.452-.416 12.212 12.212 0 012.156.369.328.328 0 01.225.426l-.645 1.824a.625.625 0 101.178.417l.614-1.738a.417.417 0 01.562-.242 11.974 11.974 0 011.728.933.417.417 0 01.188.348z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeight);
export default __webpack_public_path__ + "static/media/weight.516beb75.svg";
export { ForwardRef as ReactComponent };